module.exports = __webpack_public_path__ + "static/img/quxiaoquantijingyin2.98ed2fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/quxiaoquantijingyin2.png
// module id = BhhB
// module chunks = 24